@use "@fukuri-admins/ui/layout" as *;

.screen {
  @include screen;
}

.content {
  @include content;
}

.body {
  @include body;
}

.ScheduleAlertWrapper {
  padding: spacing('24') spacing('24') spacing('0');
}

.BannerWrapper {
  position: fixed;
  bottom: spacing('24');
  right: spacing('24');
}
